import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'

const AgentBanner = ({ image }) => {
  return (
    <section className='agent-banner'>
      <div className='agent-banner__inner'>
        <Fade bottom distance='40px'>
          { image?.localFile  && <GatsbyImage image={getImage(image.localFile)} alt={image.altText} /> }
        </Fade>
      </div>
    </section>
  )
}

export default AgentBanner
